module.exports = __webpack_public_path__ + "img/thumbnail_mobile.c82da53f.png";